import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.333 14.1v2.5a1.667 1.667 0 0 1-1.816 1.666 16.5 16.5 0 0 1-7.192-2.558 16.25 16.25 0 0 1-5-5 16.5 16.5 0 0 1-2.558-7.225 1.667 1.667 0 0 1 1.658-1.817h2.5A1.67 1.67 0 0 1 7.592 3.1c.105.8.301 1.586.583 2.342A1.67 1.67 0 0 1 7.8 7.2L6.742 8.258a13.33 13.33 0 0 0 5 5l1.058-1.059a1.67 1.67 0 0 1 1.758-.375c.757.283 1.542.478 2.342.584a1.667 1.667 0 0 1 1.433 1.691" }, null, -1)
  ]))]))
}
export default { render: render }